export default {
    result: {
        text: '1 micro-trend was identified based on the selected search query. | {total} micro-trends were identified based on the selected search query.',
        link: 'View all'
    },
    alternative: `Attention: As soon as the search agent identifies new micro-trends, they will be displayed here.
  You can set an individual notification interval in the settings of the work space to be informed via e-mail when new micro-trends are identified by the search agent.`
}
